import * as React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Separator } from '@/components/forms/ui/separator';
import { VisualizationBlock } from './visualization/visualization-block';
import { decodeVizParams } from './visualization/viz-url-params';

export function VizPage() {
  const [searchParams] = useSearchParams();
  const result = React.useMemo(() => decodeVizParams(searchParams), [searchParams]);

  if (!result) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background">
        <div className="text-center">
          <p className="mb-2 text-sm text-muted-foreground">
            Invalid or missing visualization parameters.
          </p>
          <Link to="/chat" className="text-sm text-primary underline">
            Back to Chat
          </Link>
        </div>
      </div>
    );
  }

  const title = 'title' in result.labeledViz ? result.labeledViz.title : 'Visualization';

  return (
    <div className="flex h-screen min-w-0 flex-col bg-background">
      <div className="px-6 py-4">
        <h1 className="text-lg font-semibold">{title}</h1>
      </div>

      <Separator />

      <div className="flex-1 overflow-auto px-6 py-6">
        <div className="mx-auto w-full max-w-7xl">
          <VisualizationBlock
            cubeQuery={result.query}
            vizStatus="complete"
            visualization={{ query: result.query, labeledViz: result.labeledViz }}
          />
        </div>
      </div>
    </div>
  );
}
